import { TextButton } from '@wix/design-system';
import { DomainSearchSuiteModule } from '@wix/domains-search-suite';
import { parseDomain } from '@wix/domains-serverless-interface';
import React from 'react';
import { MobileStatusBox } from './MobileStatusBox';
export const MobileSubdomainRootTaken = _ref => {
  let {
    domainName,
    action,
    datahook
  } = _ref;
  const {
    Trans
  } = DomainSearchSuiteModule.internals.useTranslations();
  const parsedDomain = parseDomain(domainName ?? '');
  const {
    formattedInput
  } = parseDomain(parsedDomain.main);
  return /*#__PURE__*/React.createElement(MobileStatusBox, {
    datahook: datahook
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "domain_search_suite.error.subdomain",
    values: {
      domainName: formattedInput
    },
    components: [/*#__PURE__*/React.createElement(TextButton, {
      size: "small",
      weight: "thin",
      underline: "always",
      onClick: action
    })]
  }));
};
//# sourceMappingURL=MobileSubdomainRootTaken.js.map